import axios from "axios";
import { isMobileDevice } from "./device";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_URL = `${BACKEND_URL.replace(/^http/, "ws")}/api/ws`;

export const TOKEN_KEY = "tc_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));
export const CLIENT_KIND = isMobileDevice() ? "mobile" : "desktop";

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  config.headers["X-TC-Client"] = CLIENT_KIND;
  return config;
});
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err?.response?.data?.detail || "";
    if (err?.response?.status === 403 && detail === "mobile_blocked") {
      window.dispatchEvent(new Event("tc:mobile-blocked"));
      return Promise.reject(err);
    }
    const deactivated = err?.response?.status === 403 && /deactivated/i.test(detail);
    if ((err?.response?.status === 401 || deactivated) && getToken()) {
      setToken(null);
      window.dispatchEvent(new Event("tc:logout"));
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (d && typeof d === "object") return d.message || fallback;
  return d || e?.message || fallback;
};
